import type {
  IServerErrorResponse,
  IServerSuccessResponse,
} from "draivn-ui-domain";

export const HEALTH_CHECK_URL = "api/v1/health/check";

export type HealthCheckData = { status: string }[];

export type HealthCheckResponse =
  | IServerErrorResponse
  | IServerSuccessResponse<HealthCheckData>;

export const isHealthCheckUp = (
  response: HealthCheckResponse,
  isRequestSuccess: (
    response: HealthCheckResponse
  ) => response is IServerSuccessResponse<HealthCheckData>
): boolean => {
  return (
    isRequestSuccess(response) &&
    !!response.data &&
    response.data.length > 0 &&
    response.data[0].status === "UP"
  );
};
